import React from 'react';

const PageNotFound = () => {
    return(
        <div id="pagenotfound">
            <div className="big_demon_404"></div>
            <div className="big_zombie_404"></div>
            <div className="big_demon_404"></div>
            <div className="big_ogre_404"></div>
            <div className="big_zombie_404"></div>
            <div className="big_demon_404"></div>
            <div className="big_ogre_404"></div>
            <div>PAGE COULD NOT BE FOUND</div>
            <div className="notfoundtext">Monsters probably got to it first.</div>
            <div className="big_demon_404 reverse"></div>
            <div className="big_zombie_404 reverse"></div>
            <div className="big_demon_404 reverse"></div>
            <div className="big_ogre_404 reverse"></div>
            <div className="big_zombie_404 reverse"></div>
            <div className="big_demon_404 reverse"></div>
            <div className="big_ogre_404 reverse"></div>
        </div>
    )
}

export default PageNotFound